import { render, staticRenderFns } from "./brandManage.vue?vue&type=template&id=6f310bc6"
import script from "./brandManage.vue?vue&type=script&lang=ts"
export * from "./brandManage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports